var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 43.7833,
    fill: "#BC172F",
    fillOpacity: 0.1,
    stroke: "#BC172F",
    strokeWidth: 0.433498
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 57.5,
    r: 57.5,
    fill: "#BC172F",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0448 65.419L44.0877 58.4619C43.7128 58.0871 43.2044 57.8764 42.6742 57.8764C42.1441 57.8764 41.6356 58.0871 41.2608 58.4619C40.8859 58.8368 40.6753 59.3452 40.6753 59.8754C40.6753 60.1379 40.727 60.3978 40.8275 60.6404C40.9279 60.8829 41.0752 61.1033 41.2608 61.2889L49.6414 69.6695C50.4233 70.4514 51.6864 70.4514 52.4683 69.6695L73.6804 48.4573C74.0553 48.0825 74.2659 47.574 74.2659 47.0439C74.2659 46.5137 74.0553 46.0053 73.6804 45.6304C73.3056 45.2555 72.7971 45.0449 72.267 45.0449C71.7368 45.0449 71.2284 45.2555 70.8535 45.6304L51.0448 65.419Z",
    fill: "#BC172F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.e6a4d8d56661b234fde9224bfdf63535.svg";
export { ForwardRef as ReactComponent };